import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { connect } from "react-redux";
//import find from "lodash.find";
import { showNotification as showNotificationAction } from "admin-on-rest";

import { forEach } from "lodash";
import compose from "recompose/compose";
import { Card } from "material-ui/Card";
import { Flex, Box } from "rebass";
import { GET_LIST } from "admin-on-rest";
import { ViewTitle } from "admin-on-rest/lib/mui";
import { cyan500 } from "material-ui/styles/colors";
import ActionEdit from "material-ui/svg-icons/content/create";
import IconButton from "material-ui/IconButton";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from "material-ui/Table";
import TextField from "material-ui/TextField";
import ModalEditDetail from "./ModalEditDetail";
import IconTitle from "../components/icon_title";
import { RestClient, RestApiUpdateSimCards } from "../restClient";

class SimDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      oldList: [],
      openDialog: false,
      itemSelected: {}
    };
  }
  componentWillMount() {
    this.getDetailSim();
  }
  getDetailSim() {
    const { simParams, showNotification } = this.props;
    if (simParams && simParams.id) {
      // const id = simParams.id * 1;
      const url = `simCardBatchs/${simParams.id}`;
      RestClient(GET_LIST, url, {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "created_at", order: "ASC" }
      })
        .then(items => {
          if (items && items.data) {
            this.setState({ list: items.data, oldList: items.data });
          } else {
            showNotification("resources.sim.actions.warning", "warning");
          }
        })
        .catch(e => {
          console.error(e);
          showNotification("resources.sim.actions.warning", "warning");
        });
    }
  }

  setItemSim() {}
  handleCloseDialog = () => {
    this.setState({ openDialog: false, itemSelected: {} });
  };
  handleSaveDialog = data => {
    let dataold = this.state.oldList;
    let dataoldList = this.state.list;
    const { showNotification } = this.props;
    RestApiUpdateSimCards(data)
      .then(response => response.json())
      .then(items => {
        const itemOld = [];
        if (items && items.id) {
          forEach(dataold, function(value) {
            if (value.id === items.id) {
              value = items;
            }
            itemOld.push(value);
          });
          const itemOldList = [];
          forEach(dataoldList, function(value) {
            if (value.id === items.id) {
              value = items;
            }
            itemOldList.push(value);
          });
          this.setState({
            openDialog: false,
            itemSelected: {},
            oldList: itemOld,
            list: itemOldList
          });
          showNotification("resources.sim.actions.updated");
        } else {
          showNotification("resources.sim.actions.warning", "warning");
        }
      })
      .catch(e => {
        showNotification("resources.sim.actions.warning", "warning");
        //console.error(e);
      });
  };
  handleOpenDialog = item => {
    this.setState({
      openDialog: true,
      itemSelected: item
    });
  };
  onSearch = (event, value) => {
    setTimeout(this.onResultSearch.bind(this, value), 500);
  };

  onResultSearch = value => {
    const { oldList } = this.state;
    const result = [];
    oldList.map((item, index) => {
      const type = item.type.toLowerCase();
      const valueType = value.toLowerCase();
      if (
        (item.msisdn && item.msisdn.search(new RegExp(value)) !== -1) ||
        (item.sim_card_number &&
          item.sim_card_number.search(new RegExp(value)) !== -1) ||
        (type && type.search(new RegExp(valueType)) !== -1) ||
        (item.status && item.status.search(new RegExp(value)) !== -1)
      ) {
        result.push(item);
        return item;
      }
      return null;
    });
    this.setState({
      list: result
    });
  };

  render() {
    const { list, itemSelected } = this.state;
    return (
      <Card containerStyle={{ minHeight: 300 }}>
        <ViewTitle
          title={
            <Flex w={[1]} direction={["row"]} justify={["space-between"]}>
              <IconTitle
                icon="sim"
                title={this.props.dateCurrentSim}
                isTranlate={false}
              />
              <Box>
                <TextField
                  hintText="Search..."
                  onChange={this.onSearch.bind(this)}
                />
              </Box>
            </Flex>
          }
        />
        <Box w={[1]} p={[1]}>
          <Table selectable={false}>
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn>MSISDN</TableHeaderColumn>
                <TableHeaderColumn>SIM Card #</TableHeaderColumn>
                <TableHeaderColumn>Type</TableHeaderColumn>
                <TableHeaderColumn>Expiry Date</TableHeaderColumn>
                <TableHeaderColumn>Status</TableHeaderColumn>
                <TableHeaderColumn
                  style={{ width: 50, paddingLeft: 10, paddingRight: 10 }}
                />
              </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
              {list &&
                list.map((item, index) => {
                  const status = item.status.toUpperCase();
                  const type = item.type.toUpperCase();
                  return (
                    <TableRow key={index}>
                      <TableRowColumn>{item.msisdn}</TableRowColumn>
                      <TableRowColumn>{item.sim_card_number}</TableRowColumn>
                      <TableRowColumn>{type}</TableRowColumn>
                      <TableRowColumn>
                        {moment(item.expiry_date).format("DD-MM-YYYY")}
                      </TableRowColumn>
                      <TableRowColumn>{status}</TableRowColumn>
                      <TableRowColumn
                        style={{ width: 50, paddingLeft: 10, paddingRight: 10 }}
                      >
                        <IconButton
                          iconStyle={{ color: cyan500 }}
                          onClick={this.handleOpenDialog.bind(this, item)}
                        >
                          <ActionEdit />
                        </IconButton>
                      </TableRowColumn>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </Box>
        {itemSelected &&
          itemSelected.id && (
            <ModalEditDetail
              {...this.props}
              open={this.state.openDialog}
              dataSelected={this.state.itemSelected}
              handleClose={this.handleCloseDialog.bind(this)}
              handleSave={this.handleSaveDialog.bind(this)}
            />
          )}
      </Card>
    );
  }
}

SimDetail.propTypes = {
  showNotification: PropTypes.func
};
const enhance = compose(
  connect(
    (state, props) => {
      const simParams = props.match.params;
      const recordSim = props.location.state;
      let data = "";
      if (recordSim) {
        data = moment(recordSim.created_at).format("YYYY-MM-DD");
        localStorage.setItem("CURRENT_SIMCARD_ITEM", JSON.stringify(recordSim));
      } else {
        const items = localStorage.getItem("CURRENT_SIMCARD_ITEM");
        const item = JSON.parse(items);
        if (item) {
          data =
            simParams.id * 1 === item.id * 1
              ? moment(item.created_at).format("YYYY-MM-DD")
              : "";
        } else {
          localStorage.removeItem("CURRENT_SIMCARD_ITEM");
          data = "";
        }
      }
      return {
        simParams,
        dateCurrentSim: data
      };
    },
    { showNotification: showNotificationAction }
  )
);

export default enhance(SimDetail);



// WEBPACK FOOTER //
// ./src/sim/Detail.js